"use strict";
exports.__esModule = true;
exports.useLogger = exports.LoggerContext = void 0;
var react_1 = require("react");
var defaultLogFn = function () { return null; };
/**
Context for providing logging functionality to React components.
The value must implement the {@link Logger} interface
*/
exports.LoggerContext = react_1.createContext({
    warn: defaultLogFn,
    error: defaultLogFn,
    log: defaultLogFn,
    logClientEvent: defaultLogFn,
    logEventWithoutPrivateInfo: defaultLogFn
});
/**
 * Hook to gain access to a logger provided via React's Context Api.
 */
exports.useLogger = function () { return react_1.useContext(exports.LoggerContext); };
//# sourceMappingURL=LoggerContext.js.map